module.exports = __webpack_public_path__ + "static/media/maternity8.3f277fb4.jpg";